module.exports = __webpack_public_path__ + "img/comfort.157b2010.jpg";